export default {
  install: (app, options) => {
    const isCustomChallengeFinished = (
      customChallenge,
      useLastProgressDeactivation = false
    ) => {
      const exceededDeactivationTime = useLastProgressDeactivation
        ? lastProgressExceededDeactivationTime(customChallenge)
        : hasExceededDeactivationTime(customChallenge);

      return (
        hasReachedTargetValue(customChallenge) ||
        exceededDeactivationTime ||
        hasReachedMaxEntries(customChallenge)
      );
    };

    const hasReachedTargetValue = (customChallenge) => {
      let userProgress = customChallenge.userProgressSum;
      if (customChallenge.isTeamChallenge) {
        userProgress = customChallenge.allUsersProgressSum;
      }

      return (
        customChallenge.targetValue &&
        userProgress >= customChallenge.targetValue
      );
    };

    const hasReachedMaxEntries = (customChallenge) => {
      return (
        customChallenge.maxAmount &&
        customChallenge.userProgressCountTotal >=
          (customChallenge.maxAmount ?? 99999)
      );
    };

    const hasStartedChallenge = (customChallenge) => {
      return customChallenge.userStartAt ?? false;
    };

    const isAllowedToChangeHistoryProgresses = (customChallenge) => {
      let show = true;

      // Dont show button if max answer amount has been reached
      if (hasReachedMaxEntries(customChallenge)) {
        show = false;
      }

      // User has not started challenge, endDate has been exceeded, startDate has not been reached yet
      if (
        !hasStartedChallenge(customChallenge) &&
        (new Date() > new Date(customChallenge.endAt) ||
          new Date() < new Date(customChallenge.startAt))
      ) {
        show = false;
      }

      // User hast started challenge, but deactivation time has been reached -> dont allow to add progress
      if (
        hasStartedChallenge(customChallenge) &&
        hasExceededDeactivationTime(customChallenge)
      ) {
        show = false;
      }

      // User has reached target value
      if (hasReachedTargetValue(customChallenge)) {
        show = false;
      }

      return show;
    };

    const isAllowedToChangeProgress = (customChallenge) => {
      let show = true;

      // Limit = 1 and user has already submitted a value for this interval
      if (
        customChallenge.limit === 1 &&
        customChallenge.userProgressSumCurrentInterval !== 0
      ) {
        show = false;
      }

      // Dont show button if max answer amount has been reached
      if (hasReachedMaxEntries(customChallenge)) {
        show = false;
      }

      // User has not started challenge, endDate has been exceeded, startDate has not been reached yet
      if (
        !hasStartedChallenge(customChallenge) &&
        (new Date() > new Date(customChallenge.endAt) ||
          new Date() < new Date(customChallenge.startAt))
      ) {
        show = false;
      }

      // User hast started challenge, but deactivation time has been reached -> dont allow to add progress
      if (
        hasStartedChallenge(customChallenge) &&
        hasExceededDeactivationTime(customChallenge)
      ) {
        show = false;
      }

      // User has reached target value
      if (hasReachedTargetValue(customChallenge)) {
        show = false;
      }

      return show;
    };

    const hasExceededDeactivationTime = (customChallenge) => {
      return (
        new Date() > new Date(customChallenge.userEndAt) ||
        new Date() > new Date(customChallenge.deactivationAt)
      );
    };

    const lastProgressExceededDeactivationTime = (customChallenge) => {
      return (
        customChallenge.lastProgressDate &&
        new Date(customChallenge.lastProgressDate) >
          new Date(customChallenge.deactivationAt)
      );
    };

    const hasUserFinishedCompetitionSuccessful = (customChallenge) => {
      let progress = customChallenge.userProgressSum;
      let target = customChallenge.competitionMinimumValue;

      return customChallenge.hasCompetition && progress >= target;
    };

    app.config.globalProperties.$customChallengeManager = {
      isCustomChallengeFinished,
      hasReachedTargetValue,
      hasReachedMaxEntries,
      hasExceededDeactivationTime,
      hasStartedChallenge,
      lastProgressExceededDeactivationTime,
      isAllowedToChangeProgress,
      isAllowedToChangeHistoryProgresses,
      hasUserFinishedCompetitionSuccessful,
    };
  },
};
